<input
  type="text"
  aria-label="Search"
  style="border: 1px solid transparent !important"
  class="search-box"
  [placeholder]="placeHolderName"
  [(ngModel)]="autocompleteInput"
  #addresstext
/>
